import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

import { NextArrowIcon } from "../assets/icons/go-hire-page-icons";
import { getJobDetailsRoute } from "../../../routers/routeUtils";
import { useNavigate } from "react-router-dom";

const CreateJobFooter = ({
  handleGoBack,
  backButtonLabel,
  handleGoToNextStep,
  nextButtonLabel,
  isSubmitting = false,
  handlePreviewClick,
  BackButtonIcon,
  jobId,
  showPreviewButton = true,
}: {
  handleGoBack: () => void;
  backButtonLabel: string;
  handleGoToNextStep: () => void;
  nextButtonLabel?: string;
  isSubmitting?: boolean;
  handlePreviewClick: () => void;
  BackButtonIcon: JSX.Element;
  jobId: number | null;
  showPreviewButton?: boolean;
}) => {
  const { t } = useTranslation("goHire", { keyPrefix: "createJobPage" });

  const navigate = useNavigate();
  const handleNavigateToJobPage = () => {
    if (!jobId) return;
    navigate(getJobDetailsRoute(jobId));
  };

  return (
    <Box sx={styles.container} component="footer">
      <Box sx={styles.footerContainer}>
        {jobId && (
          <Button
            sx={styles.cancelButton}
            variant="outlined-md"
            startIcon={BackButtonIcon}
            onClick={handleNavigateToJobPage}
          >
            {t("jobPage")}
          </Button>
        )}
        {!jobId && (
          <>
            <Button
              sx={styles.cancelButton}
              variant="outlined-md"
              startIcon={BackButtonIcon}
              onClick={handleGoBack}
              disabled={isSubmitting}
            >
              {backButtonLabel}
            </Button>
            <Box sx={styles.footerButtonsContainer}>
              {showPreviewButton && (
                <Button type="button" variant="outlined-md" onClick={handlePreviewClick} disabled={isSubmitting}>
                  {t("preview")}
                </Button>
              )}
              <Button
                variant="primary-md"
                endIcon={<NextArrowIcon />}
                onClick={handleGoToNextStep}
                disabled={isSubmitting}
              >
                {nextButtonLabel || t("next")}
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default CreateJobFooter;

const styles = {
  container: {
    background: "var(--White, #FFF)",
    padding: "16px 0 24px 0",
    borderTop: "1px solid var(--Gray---100, #E7E7E7)",
    boxShadow: "0 -4px 16px 0 rgba(0, 0, 0, 0.04)",
  },
  footerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: "1140px",
    width: "80%",
    margin: "0 auto",
  },
  footerButtonsContainer: {
    display: "flex",
    gap: "16px",
  },
  cancelButton: {
    color: "var(--Gray-700, #344054) !important",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    border: "1px solid var(--Gray-300, #D0D5DD) !important",
    background: "var(--Base-White, #FFF) !important",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05) !important",
  },
};
